import Phaser from 'phaser';

import * as C from 'tower/constants';
import gameState from 'tower/state/game-state';
import { wait } from 'tower/util';

export default class BaseScene extends Phaser.Scene {
  fadeRect!: Phaser.GameObjects.Rectangle;

  loadResources(_scene: Phaser.Scene) {}

  create() {
    this.handleVolumeChanged(gameState.volume);
    gameState.on('volumechanged', this.handleVolumeChanged);
    this.events.once('shutdown', () => {
      gameState.off('volumechanged', this.handleVolumeChanged);
    });

    this.fadeRect = this.add
      .rectangle(128, 128, 256, 256, 0x000000)
      .setAlpha(0)
      .setDepth(C.DEPTHS.Fade)
      .setScrollFactor(0);
  }

  handleVolumeChanged = (volume: number) => {
    // Exponential for a more smooth perceived ramp
    this.sound.setVolume(Phaser.Math.Easing.Cubic.In(volume));
  };

  async fadeIn() {
    await wait(this, 300);
    this.fadeRect.setAlpha(0);
  }

  async fadeOut() {
    this.fadeRect.setAlpha(1);
    await wait(this, 300);
  }
}
